import { ArrowBackIcon } from '@chakra-ui/icons'
import { Text, Icon, Button, Flex, Center, Link } from '@chakra-ui/react'
import { Slash } from 'react-feather'

const PermissionDenied = () => {
  return (
    <Flex
      height={'100%'}
      color={'#2c1c70'}
      //   flexDir={'column'}
      alignItems={'center'}
      justifyContent={'center'}
    >
      <Center flexBasis={'50%'} flexDir={'column'}>
        <Icon as={Slash} boxSize={200} color={'danger'} />
        <Text fontSize={150} fontWeight={'bold'}>
          403
        </Text>
      </Center>
      <Center
        flexBasis={'50%'}
        height={'100%'}
        bg={'#2c1c70'}
        flexDir={'column'}
        color={'white'}
      >
        <Text fontSize={'5xl'}>Access Denied</Text>
        <Text fontSize={'2xl'} width={'40%'} textAlign={'center'} mt={6}>
          Sorry about that, but you don't have the permission to view this page
        </Text>
        <Text mt={10} fontSize={'xl'}>
          But you can go back to home page
        </Text>
        <Link href="/" mt={4}>
          <Button
            leftIcon={<ArrowBackIcon />}
            // colorScheme="purple"
            variant="solid"
          >
            Back to Home page
          </Button>
        </Link>
      </Center>
    </Flex>
  )
}

export default PermissionDenied
